import { Dispatch } from 'redux'

import { useThunkActions } from 'redux/actions/useThunkActions'
import {
  getAll,
  getAllByAnalysis,
  getAllByReportEdition,
  create,
  update,
  destroy
} from 'redux/api/Comments'

import { CreateCommentBody, UpdateCommentBody } from 'types/GlobalComment'

import * as actions from './actions'

export function tryGetAllComments(keyMetricId: string) {
  return (dispatch: Dispatch) => {
    dispatch(actions.getAll(keyMetricId))

    getAll(keyMetricId)
      .then((response) => {
        dispatch(
          actions.getAllSuccess({
            data: response.data.data,
            keyMetricId
          })
        )
      })
      .catch(() => {
        dispatch(actions.getAllFailed())
      })
  }
}

function tryCreateComment(
  body: CreateCommentBody,
  cb?: (err?: boolean) => void
) {
  return (dispatch: Dispatch) => {
    dispatch(actions.create())

    create(body)
      .then((response) => {
        dispatch(actions.createSuccess(response.data))

        if (cb) {
          cb()
        }
      })
      .catch(() => {
        dispatch(actions.createFailed())

        if (cb) {
          cb(true)
        }
      })
  }
}

function tryUpdateComment(
  id: string,
  body: UpdateCommentBody,
  cb?: (err?: boolean) => void
) {
  return (dispatch: Dispatch) => {
    dispatch(actions.update())

    update(id, body)
      .then((response) => {
        dispatch(actions.updateSuccess(response.data))

        if (cb) {
          cb()
        }
      })
      .catch(() => {
        dispatch(actions.updateFailed())

        if (cb) {
          cb(true)
        }
      })
  }
}

function tryDeleteComment(id: string, cb?: (err?: boolean) => void) {
  return (dispatch: Dispatch) => {
    dispatch(actions.destroy())

    destroy(id)
      .then(() => {
        dispatch(actions.destroySuccess(id))

        if (cb) {
          cb()
        }
      })
      .catch(() => {
        dispatch(actions.destroyFailed())

        if (cb) {
          cb(true)
        }
      })
  }
}

export function tryGetAllCommentsByReportEdition(reportEditionId: string) {
  return (dispatch: Dispatch) => {
    dispatch(actions.getAll(reportEditionId))

    getAllByReportEdition(reportEditionId)
      .then((response) => {
        dispatch(
          actions.getAllSuccess({
            data: response.data.data,
            reportEditionId
          })
        )
      })
      .catch(() => {
        dispatch(actions.getAllFailed())
      })
  }
}

export function tryGetAllCommentsByAnalysis(analysisId: string) {
  return (dispatch: Dispatch) => {
    dispatch(actions.getAll(analysisId))

    getAllByAnalysis(analysisId)
      .then((response) => {
        dispatch(
          actions.getAllSuccess({
            data: response.data.data,
            analysisId
          })
        )
      })
      .catch(() => {
        dispatch(actions.getAllFailed())
      })
  }
}

export const useCommentActions = () => {
  return {
    tryCreateComment: useThunkActions(tryCreateComment),
    tryDeleteComment: useThunkActions(tryDeleteComment),
    tryGetAllComments: useThunkActions(tryGetAllComments),
    tryGetAllCommentsByAnalysis: useThunkActions(tryGetAllCommentsByAnalysis),
    tryGetAllCommentsByReportEdition: useThunkActions(
      tryGetAllCommentsByReportEdition
    ),
    tryUpdateComment: useThunkActions(tryUpdateComment)
  }
}
